import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { SharedModule } from 'src/app/shared/shared.module';
import { TableSezioniComponent } from './components/table-sezioni/table-sezioni.component';
import { GestioneClassQualComponent } from './gestione-class-qual.component';
import { AnagraficaClassificaComponent } from './components/anagrafica-classifica.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ButtonModule,
    TableModule,
    DialogModule,
    InputTextModule,
    ListboxModule,
    ToastModule,
    RadioButtonModule,
    AnagraficaClassificaComponent
  ],
  exports: [
    GestioneClassQualComponent
  ],
  declarations: [
    GestioneClassQualComponent,
    TableSezioniComponent,
  ],
  providers: [],
})
export class GestioneClassQualModule { }
